<div >
  <!-- <div class="mapviewSearch">
      <input class="form-control" (keyup)="onTextChanges($event)" type="text" [(ngModel)]="searchText" placeholder="Search properties" />
  </div> -->
  <div class="col-md-6 col-lg-6 col-sm-6 col-xs-6 fullwidth600" *ngFor="let location of locations">
      <be-property-card [property]="location" ></be-property-card>
  </div>
</div>
